<template>
  <div class="home">
    <Header></Header>
    <div class="section">
      <router-view></router-view>
    </div>
    <Footer></Footer>
    <div class="qr-code">
      <img src="@/assets/img/qr-code.jpg" alt="">
      <p>托乐乐云端助教”官方公众号</p>
      <p>关注后可进行问题咨询</p>
    </div>
  </div>
</template>

<script>
import Header from './header/header';
import Footer from './footer/footer';

export default {
  name: 'home',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
.home {
  .qr-code {
    position: fixed;
    right: 20px;
    top: 50%;
    text-align: center;
    font-size: 12px;
    img {
      width: 120px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue